/* eslint-disable react-hooks/exhaustive-deps */
import {FC, useContext, useState, useEffect, useMemo} from 'react'
import {useQuery} from 'react-query'
import {
  initialQueryState,
  PaginationState,
  QUERIES,
  WithChildren,
} from '../../../../../_dashboard/helpers'
import {useQueryRequest} from './QueryRequestProvider'
import {getAll} from '../../../../services/common_requests'
import { createFooterResponseContext, Footer, initialFooterQueryResponse,  } from './_models'

const QueryFooterResponseContext = createFooterResponseContext<Footer>(initialFooterQueryResponse)
const QueryResponseProvider: FC<WithChildren> = ({children}) => {
  const {state} = useQueryRequest()
  const [query, setQuery] = useState<any>(state)
  const updatedQuery = useMemo(() => state, [state])

  useEffect(() => {
    if (query !== updatedQuery) {
      setQuery(updatedQuery)
    }
  }, [updatedQuery])

  const {
    isFetching: isFetchingFooters,
    refetch: refetchData,
    data: dataResponse,
  } = useQuery(
    `${QUERIES.FOOTER_LIST}-${JSON.stringify(query)}`,
    () => {
      return getAll(query, '/footer')
    },
    {cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false}
  )

  return (
    <QueryFooterResponseContext.Provider
      value={{
        isLoading: isFetchingFooters,
        refetchData,
        dataResponse,
        query,
      }}
    >
      {children}
    </QueryFooterResponseContext.Provider>
  )
}

const useQueryResponse = () => useContext(QueryFooterResponseContext)

const useQueryResponseData = () => {
  const {dataResponse} = useQueryResponse();

  if (!dataResponse) {
    return [];  
  }
  return dataResponse.data;  
}
const useQueryResponsePagination = () => {
  const defaultPaginationState: PaginationState = {
    links: [],
    ...initialQueryState,
  }

  const {dataResponse} = useQueryResponse()
  if (!dataResponse || !dataResponse.payload || !dataResponse.pagination) {
    return defaultPaginationState
  }

  return dataResponse.pagination
}

const useQueryResponseLoading = (): boolean => {
  const {isLoading} = useQueryResponse()
  return isLoading
}

export {
  QueryResponseProvider,
  useQueryResponse,
  useQueryResponseData,
  useQueryResponsePagination,
  useQueryResponseLoading,
}
